import ajax from './ajax';

export function getAllUsers() {
  return ajax('/resources/get/all-staff/');
}

export function getUserDetails(data) {
  return ajax(`/resources/get/satff/${data.id}/`);
}

export function updateUserDetails(data) {
  return ajax('/resources/update/staff/', { method: 'PUT', data });
}

export function createUser(data) {
  return ajax('/resources/create/staff/', { method: 'POST', data });
}

export function deleteUser(data) {
  return ajax('/resources/delete/staff/', { method: 'DELETE', data });
}

export function exportCSV(data) {
  return ajax('/resources/user/exoprt-csv/', { method: 'POST', data });
}

export function getOptedUserBrands() {
  return ajax('/resources/user-brands/');
}

